/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';
import type { NotificationResponseDto } from './NotificationResponseDto';
import {
    NotificationResponseDtoFromJSON,
    NotificationResponseDtoFromJSONTyped,
    NotificationResponseDtoToJSON,
    NotificationResponseDtoToJSONTyped,
} from './NotificationResponseDto';

/**
 * 
 * @export
 * @interface NotificationListResponseDto
 */
export interface NotificationListResponseDto {
    /**
     * 
     * @type {Array<NotificationResponseDto>}
     * @memberof NotificationListResponseDto
     */
    data: Array<NotificationResponseDto>;
    /**
     * 
     * @type {PaginationDto}
     * @memberof NotificationListResponseDto
     */
    pagination: PaginationDto;
}

/**
 * Check if a given object implements the NotificationListResponseDto interface.
 */
export function instanceOfNotificationListResponseDto(value: object): value is NotificationListResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function NotificationListResponseDtoFromJSON(json: any): NotificationListResponseDto {
    return NotificationListResponseDtoFromJSONTyped(json, false);
}

export function NotificationListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(NotificationResponseDtoFromJSON)),
        'pagination': PaginationDtoFromJSON(json['pagination']),
    };
}

export function NotificationListResponseDtoToJSON(json: any): NotificationListResponseDto {
    return NotificationListResponseDtoToJSONTyped(json, false);
}

export function NotificationListResponseDtoToJSONTyped(value?: NotificationListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(NotificationResponseDtoToJSON)),
        'pagination': PaginationDtoToJSON(value['pagination']),
    };
}

